module.exports = __webpack_public_path__ + "media/images/company-logo-05b296a7313b8dff4c04e0a07c46576a.png";